import React from 'react';
import { Stack, Text } from '@moda/om';
import { formatPrice } from '../../../../lib/formatPrice';
import { AffirmPromoMessage } from '../../../AffirmPromoMessage';
import { useOrderDetails } from '../../../OrderDetails';

export const OrderDetailsAffirmPaymentMethod: React.FC = () => {
  const { orderSummary } = useOrderDetails();

  const payTodayAmount =
    orderSummary && orderSummary.attributes.paymentSummary.payToday.price > 0
      ? formatPrice(
          orderSummary.attributes.paymentSummary.payToday.currency,
          orderSummary.attributes.paymentSummary.payToday.price
        )
      : undefined;

  return (
    <Stack space={3}>
      <AffirmPromoMessage
        pageType="cart"
        price={Number(orderSummary?.attributes.paymentSummary.payToday.price)}
      />
      <Text>
        After clicking PAY TODAY {payTodayAmount}, you will be directed to Affirm's site to select a
        financing plan and complete your purchase securely.
      </Text>
    </Stack>
  );
};
